<div class="bulleted-list" [ngClass]="{'bulleted-list--checklist': block.data.style == 'checklist'}">
  <ul class="bulleted-list__list">
    <li class="bulleted-list__list-item" *ngFor="let block of block.content; trackBy: trackByFn;" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></li>
  </ul>
</div>
